module.exports = __webpack_public_path__ + "img/合约编辑器发布.638d2ec3.jpg";